import React from 'react';
import { CONFIG } from 'config/config';


import { isMobile } from 'react-device-detect';
import * as S from './styles';


const TextProgressBar = ({ step }) => {
	console.log('step', step);
	return (
		<S.TextProgressBarWrapper>
			<S.TextProgressBar>
				{CONFIG.components.progressBar.steps.map((item, index, list) => (
					<S.TextProgressBarItem key={`pbi-${index}`} activeStep={index === step - 1}>
						<S.TextProgressBarLabel showLabel={false} activeStep={index === step - 1}>
							{isMobile && index !== step - 1 ? (
								<>{`${index + 1}`} </>
							) : (
								<>{`${index + 1}. ${item}`} </>
							)}
						</S.TextProgressBarLabel>
					</S.TextProgressBarItem>
				))}
			</S.TextProgressBar>
		</S.TextProgressBarWrapper>
	);
};

export default TextProgressBar;
